export class Issue {
    constructor(id, title, resolved, messages, experimentEntry) {
        this.id = id;
        this.title = title;
        this.resolved = resolved;
        this.messages = messages
        this.experimentEntry = experimentEntry;
    }
}